import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import { useConfig } from '../../../DataStore/ConfigContext';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';

const CurrentPeriod = () => {
    const { openSettings } = useTheme();
    const [activeRecord, setActiveRecord] = useState(null);
    const {
        getCurrentClassExams,
        currentClassExams,
        getCurrentAcademicPeriod,
        currentAcademicPeriod
    } = useConfig();

    useEffect(() => {
        getCurrentClassExams();
        getCurrentAcademicPeriod();
    }, []);

    const handleSetCurrentPeriod = () => {
        openSettings("Set Current Period", "ConfigSetCurrentPeriod");
    };

    const handleRefresh = () => {
        setActiveRecord(null);
        getCurrentClassExams(true);
    };

    const handleChangeExam = (record) => {
        openSettings("Set Class Exam", "SetClassExam", record);
    };

    const menu = () => (
        <>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleSetCurrentPeriod}>
                <i className="dropdown-icon fa fa-plus-circle"></i>
                <span>Change Period</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleRefresh}>
                <i className="dropdown-icon fa fa-sync text-primary"></i>
                <span>Refresh</span>
            </button>
        </>
    );

    return (
        <SettingContainer
            title={`Current Period: ${currentAcademicPeriod ? `${currentAcademicPeriod.term.term} ${currentAcademicPeriod.acad_year}` : '...'}`}
            icon="fa fa-clock"
            Menu={menu}
        >
            <div className="table-responsive">
                <table className="align-middle ml-3 mb-3 table table-borderless table-striped table-hover">
                    <thead>
                        <tr>
                            <th className="text-left">Class</th>
                            <th className="text-left">Streams</th>
                            <th className="text-left">Exam</th>
                            <th className="text-left">Description</th>
                            <th className="text-left">Assessment Type</th>
                            <th className="text-left">&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(currentClassExams) && currentClassExams.length > 0 ? (
                            currentClassExams.map((item, index) => {
                                const classData = item.class;
                                const examData = item.exam?.exam || null;
                                return (
                                    <tr
                                        key={classData.class_id}
                                        onClick={() => setActiveRecord(item)}
                                        className={`${classData.class_id === activeRecord?.class?.class_id ? 'row-active' : ''}`}
                                    >
                                        <td className="text-left">{classData.class_name}</td>
                                        <td className="text-left">
                                            {Array.isArray(classData.streams) && classData.streams.length > 0 ? (
                                                classData.streams.map(stream => (
                                                    <span key={stream.stream_id} className="badge badge-info mr-1">
                                                        {stream.stream_name}
                                                    </span>
                                                ))
                                            ) : (
                                                <span className="text-muted">No Streams</span>
                                            )}
                                        </td>
                                        <td className="text-left">{examData?.exam_name || <span className="text-danger">Not Set</span>}</td>
                                        <td className="text-left">{examData?.description || '-'}</td>
                                        <td className="text-left">{examData?.assessment_type?.type_name || '-'}</td>
                                        <td className="text-left">
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => handleChangeExam(item)}
                                            >
                                                <i className="fa fa-edit"></i> Change Exam
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-muted text-center">
                                    No current exam settings found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {currentClassExams === '404' && <Notification message="No current exam settings found" />}
                {!currentClassExams && <ActivityLoader />}
            </div>
        </SettingContainer>
    );
};

export default CurrentPeriod;
